export default {
  type: "html-dnd",
  layout: "layouts/uk-coding",
  components: [
    require("fixtures/components/instructions.json"),
    require("fixtures/components/html-dnd-editor.json"),
  ],
};
